import http from '../../../Http';
import { useContext } from 'react';
import utils from '../../../utils';
import { Modal, Button, Input, Form, Select } from 'antd';
//import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import InputPrefix from '../../../utils/InputPrefix';
import { useTranslation } from 'react-i18next';

function DTUModify(props) {
    const { t } = useTranslation();
    const setTip = useContext(utils.tipContext);

    const { show, onClose, row } = props;

    const [form] = Form.useForm();

    const handleCancle = () => {
        onClose(null);
    }

    const handleSubmit = async () => {
        const ps = await form.validateFields().catch(() => { return null });

        if (ps === null) {
            return;
        }

        ps["ID"] = row.ID

        const resp = await http.post("dtu/modify", ps).then(async (r) => {
            return await r.json();
        }).catch((e) => {
            console.log("[DtuModify]", e);
            return null;
        });

        try {
            if (resp.code !== 200) {
                setTip({ open: true, severity: "error", msg: (resp && resp.msg) ? resp.msg : t("add error") });
                return
            }

            setTip({ open: true, severity: 'success', msg: t('modify success') });
            onClose(ps);
        } catch (e) {
            setTip({ open: true, severity: "error", msg: t("add error") });
        }
    }

    return (<Modal
        title={t("Modify DTU")}
        visible={show}
        cancelText={t("Cancel")}
        okText={t("Submit")}
        mask={true}
        maskClosable={false}
        width={500}
        onCancel={handleCancle}
        onOk={handleSubmit}
        footer={[
            <Button
                key="Clear"
                shape="round"
                onClick={() => {
                    form.resetFields();
                }}
            >{t("Clear")}</Button>,
            <Button key="Cancel" shape="round" onClick={handleCancle}>{t("Cancel")}</Button>,
            <Button key="Submit" shape="round" type="primary" onClick={handleSubmit}>{t("Submit")}</Button>
        ]}
    >
        <Form
            labelAlign="right"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 25 }}
            form={form}
            initialValues={row}
        >
            <Form.Item
                name="SN"
                label=""
                rules={[{ required: true }]} 
            >
                <Input prefix={<InputPrefix label={t("SN")} required />} placeholder={t("Enter DTU SN")} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Form.Item
                name="FirmwareVersion"
                label=""
                rules={[{ required: true }]} 
            >
                <Input prefix={<InputPrefix label={t("FirmwareVersion")} />} placeholder={t("Enter DTU FirmwareVersion")} style={{ borderRadius: '20px' }} />
            </Form.Item>
            <Form.Item
                name="InverterPhaseNumber"
                label=""
            >
                <Select 
                    placeholder={t("Select Inverter Phase Number")}
                    style={{ borderRadius: '20px' }}
                    allowClear
                >
                    <Select.Option value={1}>{t("Single-phase")}</Select.Option>
                    <Select.Option value={3}>{t("Three-phase")}</Select.Option>
                </Select>
            </Form.Item>
        </Form>
    </Modal>)
}

export default DTUModify;